import React from 'react';
import { formatTime } from './utils';

const TimerCard = ({ hour, minute, diff, urgent }) => (
  <div className="timer-wrap">
    <div className={`timer-card ${urgent ? 'urgent' : ''}`} id="timerCard">
      <div>
        <div className="timer-main" id="timerMain">
          Afgang {String(hour).padStart(2, '0')}:{String(minute).padStart(2, '0')} · om {formatTime(diff)}
        </div>
        <div className="timer-sub" id="timerSub">
          {diff <= 0 ? 'I skal ud ad døren nu' : urgent ? 'Skynd jer, tiden løber ud!' : 'Alle arbejder mod samme mål'}
        </div>
      </div>
      <div style={{ fontSize: '1.8rem' }}>⏰</div>
    </div>
  </div>
);

export default TimerCard;
